import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BankReconciliation, BankReconciliationCreate, BankReconciliationFilter } from '../data/bankReconciliation';

export function createBankReconciliationService(client: AxiosInstance) {
  return createCrudService<BankReconciliation, BankReconciliationCreate, BankReconciliationFilter>(
    client,
    '/accounting/BankReconciliation',
    'id',
  );
}

export type BankReconciliationService = CrudService<BankReconciliation, BankReconciliationCreate, BankReconciliationFilter>;
